/**
 * Ids are minted on the device, never assigned by storage: a save is then an
 * idempotent upsert, and a table keeps its identity through every save, merge,
 * duplicate and backup.
 */
export const newId = (): string =>
  typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : // Fallback for insecure contexts, where crypto.randomUUID is unavailable.
      'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0
        return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
      })
